// useNotify.js
import { getCurrentInstance } from 'vue';

export function useNotify() {
  const instance = getCurrentInstance();

  if (!instance || !instance.proxy) {
    console.error("useNotify must be used within the setup function of an active component.");
    return { success: () => {}, error: () => {} };
  }

  const notify = (method, options) => {
    if (instance.proxy.$notify && instance.proxy.$notify[method]) {
      instance.proxy.$notify[method](options);
    } else {
      console.error('Notification method not available');
    }
  };

  const success = (options) => {
    notify('success', options);
  };

  const error = (options) => {
    notify('error', options);
  };

  return { success, error };
}
